import { LoginPage } from './LoginPage'

export { LoginPage }



// WEBPACK FOOTER //
// ./client/Modules/LoginPage/containers/index.js